import React, { useEffect, useRef, useState } from "react";

import { API_BASE_URL_AGENT_DEV, API_BASE_URL_ISSUER } from "../../services/apiConfig";
import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, DatePicker, Input, message, Modal, QRCode, Select, TimePicker } from "antd";
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import { CheckCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import AuthService from "../../services/auth.service";
import FABBusiness from "./FABBusiness";
import FABRealTimeOrder from "./FABRealTimeOrder";
import '../../components/styles/FABRestaurant.css';
interface FABRestaurantProps {
    selectedClubInfo: any;
    profiledata: any;
}

const FABRestaurant: React.FC<FABRestaurantProps> = ({ selectedClubInfo, profiledata }) => {
    const [transactions, setTransactions] = useState<any[]>([]); // 상태 초기화
    const [businessdata, setBusinessData] = useState<any[]>([]);
    const [tableqrinfo, setTableQrInfo] = useState<any[]>([]); // 상태 초기화
    const [checkqrinfo, setcheckQrInfo] = useState<any[]>([]); // 상태 초기화
    const [qrprintmodalOpen, setqrprintmodalOpen] = useState(false);
    const [carddetailmodalOpen1, setCarddetailmodalOpen1] = useState(false);

    const [realtimeviewmodalOpen, setRealTimeViewmodalOpen] = useState(false);
    const [qrdata, setqrdata] = useState<any>("");
    const [qrLinkSeq, setqrLinkSeq] = useState<any>("");
    const [selectdeviceid, setselectdeviceid] = useState("");
    const [Qrlasttime, setQrlasttime] = useState('');
    const [Qrlasttimetime, setQrlasttimetime] = useState('');
    const [lastdate, setlastdate] = useState<dayjs.Dayjs | null>(null); // Dayjs 형식으로 상태 정의
    const qrRef = useRef<HTMLDivElement>(null);
    const [methodValue, setMethodValue] = React.useState('FNB-ORDER'); // 드롭다운 선택 상태
    const { Option } = Select;
    const [QQrmodalOpen, setQQrModalOpen] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [newqrdevice, setnewqrdevice] = useState("");
    const [token, settoken] = useState<string | null>(null);
    const [tableNumber, setTableNumber] = useState(""); // 테이블 번호 입력 상태
    const [selectclubname, setSelectClubName] = useState("");

    const [qrType, setQrType] = useState<string>(""); // QR 타입 저장
    const [newcreateqrpin, setNewCreateQrPin] = useState<string>(""); // QR 타입 저장
    const [qrModalOpen, setQrModalOpen] = useState<boolean>(false); // 추가 QR 모달 열림 상태

    const [selectdid, setselectdid] = useState<string>("");
    const [selectmemberid, setselectmemberid] = useState<string>("");
    useEffect(() => {
        // if (token !== null && profiledata.length > 0) {
        const profileData = profiledata[0];
        setselectdid(profileData.memberDid);
        setselectmemberid(profileData.memberId);
        console.log("저장한 맴버아이디 :" + profileData.memberId)
        // }
    }, [profiledata]);
    const handleTableNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTableNumber(e.target.value); // 테이블 번호 입력값 업데이트
    };

    useEffect(() => {
        fetchProviderListAPI();
    }, []);


    const qrcreateMethod = async (clubName: string) => {
        console.log("생성 버튼 클릭됨");
        try {
            const nowformattedDate = new Date().toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replace(/[^\d]/g, '');
            const devicePrefix = methodValue === "FNB-ORDER" ? "fnb_order_device_tb:" + tableNumber + "." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate : "fnb_order_check." + selectdid[0] + "." + selectedClubInfo?.club_seq + "." + nowformattedDate;

            const deviceName = methodValue === "FNB-ORDER" ? clubName + "_tb:" + tableNumber : clubName;


            const requestBody: {
                did: string;
                clubSeq: number;
                deviceId: string;
                deviceName: string;
            } = {
                did: selectdid[0],
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: devicePrefix,

                deviceName: deviceName,
            };



            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/verification/web/devices`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            console.log("변경사항1 : " + JSON.stringify(requestBody));

            const data = await response.json();
            if (response.ok) {
                console.log("data1 : " + JSON.stringify(data, null, 2));
                // qrcreate 호출하고, 핀 번호를 받아오기
                const newCreateQrPin = await qrcreate(devicePrefix, deviceName);

                // 기존 JSON 문자열
                let agentSetting = "{\"테이블\": [],\"pin\": []}";

                // JSON 문자열을 객체로 변환
                const agentSettingObj = JSON.parse(agentSetting);

                // tableNumber를 테이블 배열에 추가
                agentSettingObj["테이블"].push(tableNumber);
                agentSettingObj["pin"].push(newCreateQrPin); // 새로운 핀 번호 추가

                // 객체를 다시 JSON 문자열로 변환
                const agentSettingString = JSON.stringify(agentSettingObj);

                const requestBody1: {
                    clubSeq: number;
                    deviceId: string;
                    deviceName: string;
                    agentSetting: string;
                    title: string;
                } = {
                    clubSeq: selectedClubInfo?.club_seq || 0,
                    deviceId: devicePrefix,
                    deviceName: deviceName,
                    agentSetting: agentSettingString, // 문자열로 변환한 값을 사용
                    title: tableNumber
                };

                console.log(requestBody1); // 결과 확인 

                const response1 = await fetch(
                    `${API_BASE_URL_ISSUER}/agentsetting`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(requestBody1),
                    }
                );

                console.log("변경사항 : " + JSON.stringify(requestBody));
                const data1 = await response1.json();
                if (response1.ok) {
                    console.log("data2 : " + JSON.stringify(data1, null, 2));
                }
            }

        } catch (error) {
            console.error("Error:", error);
        }
    };
    useEffect(() => {
        const rawToken = AuthService.getRawToken();
        settoken(rawToken);
    }, []);
    const handleRealTimeViewClick = () => {
        console.log("실시간주문현황 클릭");
        const queryParams = new URLSearchParams({
            clubInfo: JSON.stringify(selectedClubInfo),
            memberId: selectmemberid.toString()
        }).toString();

        window.open(`/realtime-order?${queryParams}`, '_blank');
        // setRealTimeViewmodalOpen(!realtimeviewmodalOpen)
    };

    const qqrhandleSave = async (clubName: string) => {
        setIsButtonDisabled(true);
        QQrtoggleModal();
        const response = await fetch(
            `${API_BASE_URL_ISSUER}/presentation/verifier/name/${selectedClubInfo?.club_seq}/${clubName}`, // URL 문자열
            { // 옵션 객체
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            }
        );

        // 응답이 성공했는지 확인
        if (response.ok) {
            const data = await response.json();
            console.log("데이터확인 : " + JSON.stringify(data, null, 2));

            if (JSON.stringify(data.data.exists, null, 2) == "true") {
                setqrprintmodalOpen(!qrprintmodalOpen);
            } else {


                setnewqrdevice("")
            }

        }


        setTimeout(() => {
            // 1초 후에 버튼을 다시 활성화합니다.
            setIsButtonDisabled(false);
        }, 1000);

    }
    const QQrtoggleModal = () => {
        setQQrModalOpen(!QQrmodalOpen);

    };
    const handleQRClick = async () => {
        if (qrRef.current) {
            const canvas = await html2canvas(qrRef.current);
            canvas.toBlob(async (blob) => {
                if (blob) {
                    const item = new ClipboardItem({ 'image/png': blob });
                    await navigator.clipboard.write([item]);
                    message.info("QR 코드 이미지가 클립보드에 복사되었습니다!")
                }
            });
        }
    };
    const QrprinttoggleModal = async (methodvalue: any) => {

        setqrprintmodalOpen(!qrprintmodalOpen);
        if (!qrprintmodalOpen) {

            // console.log("입력 method : " + methodvalue)

            const requestBody: {
                clubSeq: number;
                deviceId: string;
                method: any;
                longPeriod: boolean;
            } = {
                clubSeq: selectedClubInfo?.club_seq || 0,
                deviceId: "fnb_order_check_" + selectdid[0],
                method: methodValue,
                longPeriod: true,
            };
            try {

            } catch (error) {

            }
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/presentation/qrlinks`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );
            // console.log("조회 : " + JSON.stringify(requestBody));
            const data = await response.json();


            if (response.ok) {
                // console.log("내역 : " + JSON.stringify(data, null, 2))

                const jsonData = {
                    "pin": data.data.qrLinkPin,
                    "did": selectdid[0],
                    "method": methodvalue
                };

                const jsonString = JSON.stringify(jsonData);
                // console.log("qr데이터 : " + JSON.stringify(jsonData));

                setqrdata(jsonString);
                setQrlasttime(data.data.qrEndTime)
                setQrlasttimetime(data.data.qrEndTime.split(" ")[1])
                setlastdate(data.data.qrEndTime.split(" ")[0])
                // console.log("날짜확인1 : " + data.data.qrEndTime.split(" ")[0]);
                setqrLinkSeq(data.data.qrLinkSeq)

            } else {
                setqrdata("");
                const timeString = "20:00"; // 예시로 제공된 시간 문자열
                const isValidTime = /^[0-2][0-9]:[0-5][0-9]$/.test(timeString);

                if (isValidTime) {
                    setQrlasttimetime(timeString);
                } else {
                    console.error("유효하지 않은 시간 형식입니다.");
                }
                setqrLinkSeq("");
                const futureDate = dayjs().add(364, 'day').format('YYYY-MM-DD');
                setlastdate(dayjs(futureDate));
                // console.log("날짜확인2 : " + futureDate);
            }


        } else {
            setqrdata("");

            const timeString = "20:00"; // 예시로 제공된 시간 문자열
            const isValidTime = /^[0-2][0-9]:[0-5][0-9]$/.test(timeString);

            if (isValidTime) {
                const newQrlasttime = `${Qrlasttime.split(' ')[0]} ${timeString}`;
                setQrlasttimetime(newQrlasttime);
            } else {
                console.error("유효하지 않은 시간 형식입니다.");
            }
            setqrLinkSeq("");
            const futureDate = dayjs().add(364, 'day').format('YYYY-MM-DD');
            // console.log("날짜확인3 : " + futureDate);
            setlastdate(dayjs(futureDate));
        }
    };
    const fetchProviderListAPI = async () => {
        try {
            const response = await fetch(
                `${API_BASE_URL_AGENT_DEV}/fnb/contracts/${selectedClubInfo?.club_seq}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("@@" + JSON.stringify(data.data.content));
            setTransactions(data.data.content || []); // API로부터 받은 데이터를 상태에 저장, 없을 경우 빈 배열
        } catch (error) {
            console.error("(ExcelUpload) Error fetching data:", error);
        }
    };

    const fetchWebAgentSettinglist = async () => {
        if (token !== null) {
            const response = await fetch(
                `${API_BASE_URL_ISSUER}/agentsetting/list/` + selectedClubInfo?.club_seq,
                {
                    method: "GET",

                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();

            const filteredTableQR = data.data.agentSettingList.filter((item: any) =>
                item.deviceId.startsWith("fnb_order_device_tb")
            );
            const filteredCheckQR = data.data.agentSettingList.filter((item: any) =>
                item.deviceId.startsWith("fnb_order_check.did")
            );


            const formattedTableQR = filteredTableQR.map((item: any) => {
                const parsedAgentSetting = JSON.parse(item.agentSetting);
                return {
                    did: selectdid[0],
                    pin: parsedAgentSetting.pin[0], // pin 추출
                    method: "FNB-ORDER", // 고정 값
                    tableNumber: parsedAgentSetting.테이블[0]
                };
            });


            const formattedCheckQR = filteredCheckQR.map((item: any) => {
                const parsedAgentSetting = JSON.parse(item.agentSetting);
                return {
                    did: selectdid[0],
                    pin: parsedAgentSetting.pin[0], // pin 추출
                    method: "FNB-CHECK", // 고정 값
                };
            });


            console.log(JSON.stringify(formattedTableQR, null, 2));
            setTableQrInfo(formattedTableQR);
            setcheckQrInfo(formattedCheckQR)

        }
    }

    const qrcreate = async (devicePrefix: string, deviceName: string) => {
        const today: Date = new Date();
        const nextYear: Date = new Date(today);

        // 364일 후로 설정
        nextYear.setDate(today.getDate() + 364);

        // 시간대를 맞추기 위해 UTC 기준 시간을 수정 (예: 20:00)
        nextYear.setUTCHours(20, 0, 0, 0); // 20시 00분 00초로 설정

        // 'YYYY-MM-DDTHH:MM' 형식으로 날짜와 시간을 포맷
        const formattedQrLastTime: string = nextYear.toISOString().slice(0, 16);
        console.log("미래: " + formattedQrLastTime);
        const postData = {
            verifierClubSeq: selectedClubInfo?.club_seq,
            method: methodValue,
            tableNumber: tableNumber,
            deviceId: devicePrefix,
            deviceName: deviceName,
            longPeriod: true,
            qrEndTime: formattedQrLastTime,
        };

        console.log("입력값 : " + JSON.stringify(postData));

        const response = await fetch(`${API_BASE_URL_ISSUER}/presentation/verification/qrLinks`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(postData),
        });

        const data = await response.json();
        console.log("(waitinput) PUT 요청 성공:", JSON.stringify(data));
        if (data.code == 200) {
            console.log("qr 핀번호 : " + data.data.qrLinkPin);
            setNewCreateQrPin(data.data.qrLinkPin)
            const jsonData = {
                "pin": data.data.qrLinkPin,
                "did": selectdid[0],
                "method": methodValue
            };

            const jsonString = JSON.stringify(jsonData);

            console.log("qr데이터 : " + JSON.stringify(jsonData));
            if (qrdata === "") {
                message.info("새QR코드를 생성했습니다.");
            } else {
                message.info("QR코드 정보를 수정했습니다.");
            }
            setqrdata(jsonString);


            return data.data.qrLinkPin;

        }


    }

    const handleCardClick = (transaction: any) => {
        console.log(`카드클릭: ${transaction.consumerClubName}`);
        console.log(`넘긴값: ${JSON.stringify(transaction, null, 2)}`);
        setBusinessData(transaction);
        setCarddetailmodalOpen1(!carddetailmodalOpen1);
    };



    const handleQrClick = (clubName: string) => {
        console.log(`QR클릭 회사명 : ${clubName}`);
        setSelectClubName(clubName)
        qqrhandleSave(clubName);



    };

    const handleMethodChange = (value: string) => {
        setMethodValue(value); // 드롭다운 값 변경 시 상태 업데이트
    };

    const closeQRModal = () => {
        setQrModalOpen(false); // 모달 닫기
    };

    const openQRModal = (type: string) => {
        setQrModalOpen(true); // 모달 열림 상태 설정

        setQrType(type); // QR 타입 설정

        fetchWebAgentSettinglist();
        QQrtoggleModal();
    };


    return (
        <div className="layout">
            {carddetailmodalOpen1 ? (
                <div className="main-content">
                    <FABBusiness businessdata={businessdata} setCarddetailmodalOpen1={setCarddetailmodalOpen1} />
                </div>
            ) : realtimeviewmodalOpen ? (
                <div className="main-content">
                    <FABRealTimeOrder />
                </div>
            ) : (
                <div className="main-content">
                    <div className="transaction-header">
                        | 현재 거래하고 있는 회사 리스트입니다.
                    </div>
                    <Modal
                        title={`${qrType === "FNB-ORDER" ? "테이블" : "체크"} QR 정보`}
                        open={qrModalOpen} // 추가 모달 상태
                        onCancel={closeQRModal} // 추가 모달 닫기 함수
                        width={1000}
                        footer={[
                            <Button key="cancel" onClick={closeQRModal}>
                                취소
                            </Button>
                        ]} // 여기서 취소 버튼만 추가

                    >
                        {/* method가 일치하는 경우에만 QR 코드 보여주기 */}
                        {qrType === "FNB-ORDER" ? (
                            <div onClick={handleQRClick} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                    {tableqrinfo.map((data, index) => {
                                        // 여기서 tableNumber를 제외한 객체 생성
                                        const { tableNumber, ...qrDataWithoutTableNumber } = data;

                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    width: '33%', // 3열을 만들기 위해 33% 너비
                                                    padding: '10px', // QR 코드 간의 간격 추가
                                                    boxSizing: 'border-box', // padding이 포함되도록 설정
                                                    borderRight: index % 3 !== 2 ? '1px solid #ccc' : 'none', // 각 열의 끝에는 선을 없앰
                                                    borderBottom: '1px solid #ccc', // 각 행 사이에 선 추가
                                                }}
                                            >
                                                <div style={{ marginBottom: '10px' }}>
                                                    테이블 번호:  {tableNumber}
                                                </div>
                                                <QRCode
                                                    value={JSON.stringify(qrDataWithoutTableNumber)}
                                                    size={300} // 크기를 조절하여 3열 배치에 맞게 조정
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : (

                            <div onClick={handleQRClick} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>

                                    {checkqrinfo.map((data, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                width: '33%', // 3열을 만들기 위해 33% 너비
                                                padding: '10px', // QR 코드 간의 간격 추가
                                                boxSizing: 'border-box', // padding이 포함되도록 설정
                                                borderRight: index % 3 !== 2 ? '1px solid #ccc' : 'none', // 각 열의 끝에는 선을 없앰
                                                borderBottom: '1px solid #ccc', // 각 행 사이에 선 추가
                                            }}
                                        >
                                            <div style={{ marginBottom: '10px' }}>
                                                체크 QR
                                            </div>
                                            <QRCode
                                                value={JSON.stringify(data)} // QR 코드에 들어갈 데이터
                                                size={300} // 크기를 조절하여 3열 배치에 맞게 조정
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>


                        )}
                    </Modal>


                    {QQrmodalOpen && (
                        <div>
                            <Modal
                                title="QR 관리"
                                style={{ fontSize: "18px", borderRadius: "20px" }}
                                open={QQrmodalOpen}
                                onCancel={QQrtoggleModal}
                                width={600}
                                footer={[
                                    <Button key="cancel" onClick={QQrtoggleModal}>
                                        취소
                                    </Button>
                                ]} // 여기서 취소 버튼만 추가
                            >
                                {/* 기기등록 파트 */}
                                <div style={{ marginBottom: "16px", borderBottom: "1px solid black", padding: "16px" }}>
                                    <Select
                                        defaultValue="주문"
                                        style={{ width: 120, marginLeft: "8px" }} // 스타일 추가
                                        onChange={handleMethodChange}
                                    >
                                        <Option value="FNB-ORDER">주문</Option>
                                        <Option value="FNB-CHECK">체크</Option>
                                    </Select>

                                    {methodValue === "FNB-ORDER" && (
                                        <Input
                                            placeholder="테이블 번호 입력"
                                            value={tableNumber}
                                            onChange={handleTableNumberChange}
                                            style={{ width: "150px", marginLeft: "16px" }} // 입력란 스타일
                                        />
                                    )}

                                    <Button
                                        type="primary"
                                        style={{ marginLeft: "16px" }}
                                        onClick={() => qrcreateMethod(selectclubname)} // 함수 참조를 전달
                                    >
                                        생성
                                    </Button>
                                </div>
                                <div>
                                    생성된 QR 보기
                                    <div style={{ marginTop: "16px", textAlign: "center" }}>
                                        <Button
                                            type="primary"
                                            style={{ marginRight: "16px" }}
                                            onClick={() => openQRModal("FNB-ORDER")} // 테이블 QR 보기 버튼 동작
                                        >
                                            테이블 QR 보기
                                        </Button>
                                        <Button
                                            type="primary"
                                            onClick={() => openQRModal("FNB-CHECK")} // 체크 QR 보기 버튼 동작
                                        >
                                            체크 QR 보기
                                        </Button>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    )}

                    <div className="input-box">
                        <input
                            type="text"
                            className="search-input-box" // CSS와 일치하는 클래스 이름 사용
                            placeholder="검색어를 입력하세요"
                        />
                        <button className="search-button">검색</button>
                    </div>
                    <div className="providercard-container">
                        <div className="providercard add-providercard" onClick={() => alert('현재 기능 개발 중입니다')}>
                            <div className="add-icon">+</div> {/* 동그란 + 아이콘 */}
                            <div className="providercard-title" >새 거래 회사 등록하기</div>
                        </div>
                        {transactions.map((transaction) => (
                            <div className="providercard" key={transaction.consumerClubSeq} onClick={() => handleCardClick(transaction)}>
                                <div className="providercard-header">
                                    <h3>{transaction.consumerClubName}</h3>
                                    <div
                                        className="qr-icon-container"
                                        onClick={(event) => {
                                            event.stopPropagation(); // 부모 클릭 이벤트 전파 방지
                                            handleQrClick(transaction.consumerClubName); // QR 클릭 핸들러 호출
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faQrcode} className="qr-icon" />
                                    </div>
                                </div>
                                <p className="providercard-date">
                                    {transaction.startDateTime} - {transaction.endDateTime}
                                </p>
                                <p className="providercard-summary">인원 총액</p>
                                <p>{transaction.expectedCount}명 {transaction.totalPrice}원</p>
                            </div>
                        ))}
                        <button
                            className="order-status-button"
                            onClick={() => handleRealTimeViewClick()} // 클릭 시 호출할 함수
                        >
                            실시간 주문현황
                        </button>
                    </div>

                </div>
            )}
        </div>
    );
};

export default FABRestaurant;
